import React from 'react'

export default function CardDesa({name,logo,onClick}) {
  return (
    <div className="p-6 border border-cardText rounded-2xl">
      <div className="flex justify-center logoWrapper">
        <img src={logo} alt="" width={120} height={120} />
      </div>
      <p className="my-8 font-semibold text-center">{name}</p>
      <button
        type="button"
        className="w-full p-3 mt-12 font-semibold text-white rounded-2xl bg-primary"
        onClick={onClick}
      >
        Kunjungi
      </button>
    </div>
  );
}
